// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"beg_a bih_a bih_r bih_j","ModeratorInvitationListItem__left":"beg_b bih_a bih_j","ModeratorInvitationListItem__note":"beg_c bih_fo"};